import React, { Component, Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import OrderDetails from './pages/OrderDetails';
import ProductInfo from './pages/ProductInfo';
import UserManagement from './pages/UserManagement';

import Spinner from '../app/components/Spinner';

import SessionManager from './util/SessionManager';


// WARNING!!! IIS seems to have a problem with lazy loading components and composite paths
// For example the path ./pages/OrderDetails/:orderid will not work on IIS when the the 
// corresponding component is lazy loaded.

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Login = lazy(() => import('./pages/Login'))
const AEGCustFinancial = lazy(() => import('./pages/AEGCustFinancial'));
const CustomerDrafts = lazy(() => import('./pages/CustomerDrafts'))
const CustomerOpenTransactions = lazy(() => import('./pages/CustomerOpenTransactions'))
const SalesOrdersBrowser = lazy(() => import('./pages/SalesOrdersBrowser'));
const ProductCatalog = lazy(() => import('./pages/ProductCatalog'));
const SalesBasket = lazy(() => import('./pages/SalesBasket'));
const FAQ = lazy(() => import('./pages/FAQ'));
const ContactForm = lazy(() => import('./pages/AEGContactForm'));
const AccountManagement = lazy(() => import('./pages/AccountManagement'));

class AppRoutes extends Component {
    
    render() {

        // Make sure a non logged in user is allways directed to the login page
        if (!SessionManager.isUserLoggedIn) {
            return (
                <Suspense fallback={<Spinner />}>
                    <Switch>
                        <Route exact path="/login" component={Login} />
                        <Redirect to="/login" />
                    </Switch>

                </Suspense>
            )
        }
        
        return (
            <Suspense fallback={<Spinner />}>
                {this.getUserRoutes()}
                {this.getAdminRoutes()}
            </Suspense>
        );
    }

    getUserRoutes() {
        if (SessionManager.isUserAdmin)
            return;

        return (
            <Switch>
                <Route exact path="/dashboard" component={Dashboard} />

                <Route exact path="/custInfoFinancial" component={AEGCustFinancial} />
                <Route exact path="/custInfoDrafts" component={CustomerDrafts} />
                <Route exact path="/custInfoOpenTrans" component={CustomerOpenTransactions} />
                <Route exact path="/custInfoOrderHistory" component={SalesOrdersBrowser} />

                <Route exact path="/salesOrdersOrderHistory" component={SalesOrdersBrowser} />
                <Route path="/salesOrderDetails/:orderid" component={OrderDetails} />
                <Route exact path="/salesOrdersProductCatalog" component={ProductCatalog} />
                <Route exact path="/salesOrdersSalesBasket" component={SalesBasket} />
                <Route path="/productInfo/:itemId" component={ProductInfo}/>

                <Route exact path="/miscFAQ" component={FAQ} />
                <Route exact path="/miscContact" component={ContactForm} />

                <Route exact path="/accountManagement" component={AccountManagement} />

                <Redirect to="/dashboard" />
            </Switch>
        )
    }

    getAdminRoutes() {
        if (!SessionManager.isUserAdmin)
            return;
        
        return (
            <Switch>
                <Route exact path="/adminUsers/all" component={UserManagement}/>
                <Route exact path="/adminUsers/:status" component={UserManagement} />
                <Redirect to="/adminUsers/all" />
            </Switch>
        )
    }
}

export default AppRoutes;